import { Component } from '@angular/core';
import { LoadingController, NavController } from '@ionic/angular';
import { ITeam, LineUpService, TshirtStyle } from '../../../../../lineup/services/lineup-service';
import { TournamentService, IPlan, PlanEnum } from '../../../../services/tournament.service';
import { SportAlgoUtils } from '../../../../services/sport.algo';
import { Router } from '@angular/router';
import { SessionProvider } from 'src/providers/session/session';

@Component({
  selector: 'two-group-ko',
  templateUrl: 'two-group-ko.html',
  styleUrls:['./two-group-ko.scss']
})
export class TwoGruppeKoPage {
  // temporary
  events:any=[]
  // 
  plan = {
    id: 0,
    plantype: PlanEnum.GruKoPage,
    sportArt: "Fußball",
    name: "",
    rounds: 1,
    days: 7,
    games: 18,
    teamNum: 8,
    groupNum: 2,
    groupSize: 4,
    teams: [],
    gameTable: [],
    roundTeams: [],
    roundGameTable: [],
    eventId:-1,
    round:-1
  };

  constructor(
    private gs: TournamentService,
    private router:Router,
    private ls: LineUpService,
    private navCtrl: NavController,
    private loader: LoadingController,
    private sessionService: SessionProvider
  ) { }

  ionViewDidEnter() {
    this.plan.name = "Spielplan " + this.gs.planList.length;
  }

  async save() {
    this.createTeams();
    this.setMatches();
    this.gs.planList.push(this.plan);
    this.gs.save();
    let load = await this.loader.create({});
    load.present();
    // this.app.getRootNav().getActiveChildNav().select(0);
    this.navCtrl.navigateForward('/tab1');
    this.navCtrl.navigateRoot('/tab1').then(() => {
      console.log('done');
      load.dismiss();
      // this.app.getRootNav().getActiveChildNav().select(1);
      this.navCtrl.navigateForward('/tab1');
    });
  }

  filter(plan: any) {
    let obj = JSON.parse(JSON.stringify(plan));
    delete obj.gameTable;
    delete obj.roundTeams;
    delete obj.roundGameTable;
    delete obj.id;
    return obj;
  }

  async navigate() {
    let load = await this.loader.create({});
    load.present();
    // this.app.getRootNav().getActiveChildNav().select(0);
    this.navCtrl.navigateForward('/tab1').then(() => {
      console.log('done');
      load.dismiss();
      this.navCtrl.navigateForward('/tab1');;
    });
  }
  onGroupSizeChange() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
    this.plan.teamNum = Math.floor((this.plan.groupNum)) * Math.floor(this.plan.groupSize);
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onGroupNumChange() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
    this.plan.teamNum = this.plan.groupNum * this.plan.groupSize;
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onTeamNumChange(event?:any) {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
    this.plan.groupNum = this.plan.teamNum / this.plan.groupSize;
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onGroupSizeChangeMan() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
  }

  onGroupNumChangeMan() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
  }

  onTeamNumChangeMan() {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
  }

  createTeams() {
    let gN = Number(this.plan.groupNum);
    let gS = Number(this.plan.groupSize);

    let ASCII = 65;
    let id = 0;
    for (let i = 0; i < gN; i++) {
      let group = [];
      for (let j = 0; j < gS; j++) {
        let team: ITeam = {
          id: id,
          name: 'Team ' + String.fromCharCode(ASCII) + (j + 1),
          results: 0,
          points: 0,
          ord:id + 1,
          players: []
        };
        this.plan.teams.push(team);
        group.push(team);
        id += 1;
      }
      this.plan.roundTeams.push(group);
      ASCII += 1;
    }
  }

  setMatches() {
    let gN = Number(this.plan.groupNum);
    let gS = Number(this.plan.groupSize);
    for (let r = 0; r < this.plan.rounds; r++) {
      let roundTable = [];
      for (let i = 0; i < gN; i++) {
        let table = SportAlgoUtils.createGamePlan(this.plan.teams.slice(i * gS, i * gS + gS), gS, this.plan, r);
        roundTable.push(table);
      }
      this.plan.gameTable.push(roundTable);
    }
  }
  onAddEvent() {
    // this.app.getRootNav().getActiveChildNav().select(0);
    this.sessionService.getTokenAndNavigate(false, false).then(() => {
      // this.app.getRootNav().push(EventCreateTabsPage);
      this.navCtrl.navigateForward('/EventCreateTabsPage')
    });
  }


}




